/* Progress is informational. Savings always come from Shopify's actual cart totals. */
(() => {
  'use strict';
  function money(value, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {style:'currency',currency:currency || 'EUR'}).format(value / 100); }
    catch (error) { return (value / 100).toFixed(2); }
  }
  function nextMessage(s) {
    const n = Number(s.count);
    const units = x => x + (x === 1 ? ' Mochimal' : ' Mochimals');
    if (s.standalone && n < 6) return 'Puedes comprar tu artículo especial sin llegar a 6 Mochimals.';
    if (n < 6) return 'Añade ' + units(6 - n) + ' para completar tu manada.';
    if (n < 12) return units(12 - n) + ' más para llegar al 10% por cantidad.';
    if (n < 18 && s.country === 'ES') return units(18 - n) + ' más para envío gratis en España, según destino.';
    if (n < 24) return units(24 - n) + ' más para llegar al 15% por cantidad.';
    if (n < 30) return units(30 - n) + ' más para llegar al 20% por cantidad.';
    return s.savings > 0 ? 'Tu manada ya tiene descuentos aplicados. Revisa el total.' : 'Revisa tus ventajas y el total en el carrito.';
  }
  function render(s) {
    const ready = s.itemCount > 0 && (s.count >= 6 || s.standalone);
    const message = ready ? s.readyText : nextMessage(s);
    const count = s.count + (s.count === 1 ? ' Mochimal' : ' Mochimals');
    const savings = s.savings > 0 ? money(s.savings, s.currency) + ' de ahorro aplicado' : '';
    const pct = Math.min(100, Math.max(0, s.count / 30 * 100));
    const bar = document.getElementById('discount-bar-wrapper');
    if (bar) {
      bar.classList.add('visible');
      const fill = bar.querySelector('#discount-progress-bar');
      if (fill) fill.style.width = pct + '%';
      const label = bar.querySelector('#mochi-count-label');
      if (label) label.textContent = count + ' · ' + money(s.total, s.currency) + (savings ? ' · ' + savings : '');
      const next = bar.querySelector('#discount-warning');
      if (next && next.textContent !== message) next.textContent = message;
      const cta = bar.querySelector('#discount-cta-btn');
      if (cta && s.viewCartText) cta.textContent = s.viewCartText + ' →';
      bar.querySelector('#discount-cta-btn')?.classList.toggle('ready', s.itemCount > 0 && (s.count >= 6 || s.standalone));
    }
    document.querySelectorAll('[data-mz-inline-progress]').forEach(el => {
      el.querySelector('[data-mz-count]').textContent = count;
      el.querySelector('[data-mz-savings]').textContent = savings ? '· ' + savings : '';
      el.querySelector('[data-mz-fill]').style.width = pct + '%';
      el.querySelector('[data-mz-next]').textContent = message;
    });
    syncSpace();
  }
  function syncSpace() {
    const bar = document.getElementById('discount-bar-wrapper');
    const spacer = document.getElementById('discount-bar-spacer');
    if (bar && spacer) spacer.style.height = (bar.classList.contains('visible') ? bar.getBoundingClientRect().height + 12 : 0) + 'px';
  }
  document.addEventListener('mz:cart-state', e => render(e.detail));
  document.addEventListener('mz:cart-state-error', () => {
    const warning = document.getElementById('discount-warning');
    if (warning) warning.textContent = 'Abre tu carrito para comprobar el total actualizado.';
  });
  document.addEventListener('shopify:section:load', () => { if (window.MochiCart?.state) render(window.MochiCart.state); });
  if (window.MochiCart?.state) render(window.MochiCart.state);
  const bar = document.getElementById('discount-bar-wrapper');
  if (bar && typeof ResizeObserver !== 'undefined') new ResizeObserver(syncSpace).observe(bar);
})();

